import { EnhancedModel } from '../enhanced.model';

export class State extends EnhancedModel {
    private _code: string = '';
    public get code(): string {
        return this._code;
    }

    private _name: string = '';
    public get name(): string {
        return this._name;
    }

    constructor(obj: any = null) {
        super();
        if (obj !== null) {
            if (obj instanceof State) {
                this.mapClone(obj);
            } else {
                this.mapJson(obj);
            }
        }
    }

    public clone(): State {
        let cloned = new State(this);
        return cloned;
    }

    protected mapClone(obj: State) {
        this._code = obj.code;
        this._name = obj.name;
    }

    protected mapJson(obj: any) {
        if (obj.hasOwnProperty('name')) {
            this._name = obj.name;
        }
        if (obj.hasOwnProperty('code')) {
            this._code = obj.code;
        }
    }
}
